<template>
    <div class="publishModal-tree">
        <template v-for="(item, index) in treeData">
            <div class="publishModal-tree-node publishModal-tree-folder" v-if="item.type == 'folder'" @click.stop="clickFold(item)">
                <iconSymbol class="publishModal-tree-arrow" :class="{ 'publishModal-tree-arrow-openFolder': item.status }" name="ed-fold-filter" />
                <img :class="{ highlight: activeFolder == item.prefix }" :src="folderSvg" alt="" />
                <p :class="{ highlight: activeFolder == item.prefix }">{{ item.name }}</p>
                <PublishTreeNode
                    v-if="item.child.length > 0"
                    v-show="item.status"
                    :treeData="item.child"
                    :activeFile="activeFile"
                    :activeFolder="activeFolder"
                    :clickFile="clickFile"
                    :clickFold="clickFold"
                />
            </div>
            <div
                class="publishModal-tree-node publishModal-tree-file"
                :class="{ highlight: activeFile == item.id }"
                v-if="item.type == 'file'"
                @click.stop="clickFile(item)"
            >
                <img :src="fileSvg" alt="" />
                <div v-if="item.publish == 'pending' || item.publish == 'pass'" class="item-icon" :class="{ pending: item.publish == 'pending' }">
                    <iconSymbol name="publish-fill" />
                </div>
                <p>{{ item.name }}</p>
            </div>
        </template>
    </div>
</template>

<script>
    // import PublishTreeNode from './publishTreeNode.vue'
    export default {
        name: "PublishTreeNode",
        // components: {
        //     PublishTreeNode
        // },
        props: ["treeData", "activeFile", "activeFolder", "clickFile", "clickFold"],
        data() {
            return {
                fileSvg: require("@/home/parts/publishModal/eddx.svg"),
                folderSvg: require("@/home/parts/publishModal/folder.svg"),
            };
        },
        computed: {},
        methods: {},
        mounted() {},
    };
</script>

<style lang="stylus"></style>
